import { FormattedMessage } from 'react-intl';
import LinkIcon from '@atlaskit/icon/core/link';
import Link from '@atlaskit/link';
import { IconTile } from '@atlaskit/icon';

import { useToken } from '../../../../components/Flow/ConsentContextProvider';
import IconWithContent from '../IconWithContent';

const RedirectURL = () => {
  const { redirectUrl } = useToken();
  return (
    <IconWithContent
      icon={
        <IconTile icon={LinkIcon} label={''} appearance="gray" size="medium" />
      }
      text={
        <FormattedMessage
          id={'trello.redirectUrl'}
          defaultMessage={'Redirect URL: {url}'}
          values={{ url: <Link href={'#'}>{redirectUrl?.callback}</Link> }}
        />
      }
    />
  );
};

export default RedirectURL;
